import { render } from "./PdfModal.vue?vue&type=template&id=3b818578&scoped=true&ts=true"
import script from "./PdfModal.vue?vue&type=script&lang=ts"
export * from "./PdfModal.vue?vue&type=script&lang=ts"

import "./PdfModal.vue?vue&type=style&index=0&id=3b818578&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b818578"]])

export default __exports__